import React from "react";
import { LOOK } from "../look";

/**
 * Neutral cream jar: the "your product" of the story. Drawn rather than
 * borrowed from a live merchant, so no real brand is shown as someone
 * else's product.
 */
export const Jar: React.FC<{ size: number; background?: string }> = ({
  size,
  background = LOOK.sky,
}) => (
  <div
    style={{
      width: size,
      height: size,
      flex: "none",
      borderRadius: size * 0.2,
      background,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <svg
      width={size * 0.66}
      height={size * 0.66}
      viewBox="0 0 64 64"
      fill="none"
    >
      <rect x="10" y="10" width="44" height="13" rx="4" fill={LOOK.blueDeep} />
      <rect x="8" y="21" width="48" height="35" rx="9" fill={LOOK.white} />
      <rect x="15" y="31" width="34" height="14" rx="3" fill={LOOK.blue} />
      <rect x="20" y="36" width="16" height="3" rx="1.5" fill={LOOK.white} />
    </svg>
  </div>
);
